export default {"src":"/_next/static/media/developers-hero-left.fcbd3d27.svg","height":445,"width":373,"blurWidth":0,"blurHeight":0};